// extracted by mini-css-extract-plugin
export default {"layout":"layout___-peJ8"};